import { lazy } from "react";
import Loadable from "app/components/Loadable";

const GroupList = Loadable(lazy(() => import("./GroupList")));
const GroupAdd = Loadable(lazy(() => import("./GroupAdd")));

const GroupRoutes = [
  { path: "/asset/groups", element: <GroupList /> },
  { path: "/asset/groups/:mode/:id", element: <GroupAdd /> },
];

export default GroupRoutes;
